<style lang="scss" src='./Stations.scss' scoped></style>
<template src="./Stations.html"></template>

<script>
  import StationDetails from '@/views/stations/details/StationDetails.vue';
  import {
    mapState,
    mapGetters,
    mapActions,
    mapMutations,
  } from 'vuex';

  export default {
    name: 'Stations',
    components: {
      StationDetails,
    },
    data() {
      return {
        enviroment: process.env.VUE_APP_SENTRY_ENV,
        loading: {
          stations: false,
        },
      };
    },
    computed: {
      ...mapState('Stations', {
        stations: (state) => state.stations,
        station: (state) => state.station,
        rssiIcon: (state) => state.rssiIcon,
        pagination: (state) => state.pagination,
      }),
    },
    methods: {
      ...mapActions('Stations', ['apiGetStations']),
      ...mapMutations('Stations', ['setStation']),

      selectStation(station) {
        if (station) {
          this.setStation({
            ...station
          });
        }
      },

      async loadData() {
        if (this.G_isEmptyArr(this.stations)) {
          this.loading.stations = true;
        }
        await this.apiGetStations();
        if (! this.G_isEmptyArr(this.stations)) {
          this.setStation({
            ...this.stations[0]
          });
        }
        this.loading.stations = false;
      },
    },
    mounted() {
      if (process.env.VUE_APP_SENTRY_ENV == "production") {
        this.$analytics.setCurrentScreen("Web Weather Stations");
        this.$analytics.logEvent("web_weather_stations");
      }

      this.setStation({});
      this.$parent.$on('courseChange', (val) => {
        if (val) {
          this.loadData();
        }
      });
      this.loadData();
    },

    beforeDestroy() {
    },
  };

</script>
